const prod = {
  API_URL: process.env.REACT_APP_PROD_BASE_URL,
};
const dev = {
  API_URL: process.env.REACT_APP_DEV_BASE_URL,
};
export const BASE_API_URL =
  process.env.NODE_ENV === 'development' ? dev.API_URL : prod.API_URL;

export const API_URL = {
  login: BASE_API_URL + '/auth/login',
  register: BASE_API_URL + '/auth/register',
  loginWithShopifyCredentials: BASE_API_URL + '/auth/shopify/login',
  registerWithShopifyCredentials: BASE_API_URL + '/auth/shopify/register',

  filters: BASE_API_URL + '/filters/',
  // segment: BASE_API_URL + '/segment',
  stores: BASE_API_URL + '/account/stores',
  integrations: BASE_API_URL + '/integrations/',
  onboarding: BASE_API_URL + '/onboarding',
};

const level = Object.freeze({
  free: 0,
  small_business: 1,
  growth: 2,
  unlimited: 3,
  enterprise: 3,
});

/** @type {{dateSelector:number,
 * segmentsAutoSync:number,
 * segmentsSyncOnce:number,
 * segmentsLinkToSegment:number,
 * segmentsExportSegmentsList:number,
 * filters:number,segmentsSelector:number,
 * exportUsersMenu:number,
 * exportListOfCustomers:number,
 * listOfCustomersRowSelector:number,
 * listOfCustomersPagination:number,
 * addIntegration:number
 * }} */
export const subscriptionAccess = Object.freeze({
  dateSelector: level.small_business,
  segmentsAutoSync: level.small_business,
  segmentsSyncOnce: level.small_business,
  segmentsLinkToSegment: level.small_business,
  segmentsExportSegmentsList: level.small_business,
  filters: level.small_business,
  segmentsSelector: level.free,
  exportUsersMenu: level.small_business,
  exportListOfCustomers: level.small_business,
  listOfCustomersRowSelector: level.small_business,
  listOfCustomersPagination: level.small_business,
  addIntegration: level.small_business,
});

export const PAID_PLAN_TOOLTIP = 'Upgrade to access';
